{
  "version": 1,
  "asset_id": "60615d36-5601-46d0-b3ef-27c3e38cee92",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/60615d36-5601-46d0-b3ef-27c3e38cee92/gastric-bypass-es-v2-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/60615d36-5601-46d0-b3ef-27c3e38cee92/gastric-bypass-es-v2-1200.jpg",
  "original_filename": "gastric-bypass-es-v2-1200.jpg",
  "size": 116586,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:00:33Z"
}
